/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import TextInput from "../BasicInputs/TextInput.jsx";
import {Containers} from "../../Objects/Containers.jsx";
import OutputList from "../OutputList/OutputList.jsx";
import OutputListItem from "../OutputList/OutputListItem.jsx";
import {Util} from "../../Utilities.js";
import ButtonComponent from "../BasicInputs/ButtonComponent.jsx";
import {names} from "../../Constants.js";
import ElementBackups from "../ElementBackups.jsx";
import {Volumes} from "../../Objects/Volumes.jsx";
import {UI} from "../../UIGenerator.jsx";
import {Socket} from "../../Socket.js";
import {Subscription} from "../../Subscription.js";
import PasswordInputComponent from "../InputComponents/PasswordInputComponent.jsx";
import DateTime from "toolbox/dateTime";

class ContainerSettings extends Component {
    constructor() {
        super();

        this.state = {
            containerInfo: {}
        }
        this.DebouncedSave = Util.performance.debounce((handler, query) => handler(query), 300)
        this.sub = new Subscription()

    }


    async fetchData() {
        let {containerId} = this.props
        let container = await Containers(containerId).getInfo()
        this.setState({containerInfo: container ?? {}})

        this.sub.add(() => Database.table("Container", "app").onChange((change) => {
            let containerInfo = this.state.containerInfo
            containerInfo = Socket.applyChange([containerInfo], change)
            this.setState({containerInfo: containerInfo?.[0]})
        }, [{column: "containerId", value: containerId}]), "liveData")


    }

    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.containerId !== this.props.containerId) {
            this.fetchData()
        }
    }

    componentWillUnmount() {
        this.sub.unmount()
    }

    onChange(key, value) {
        let {containerInfo} = this.state

        this.setState((state) => {
            let newData = state.containerInfo
            newData[key] = value
            return ({containerInfo: newData})
        }, () => {
            this.DebouncedSave(() => {
                Containers(containerInfo.indexKey).update({[key]: this.state.containerInfo?.[key]})
            })

        })


    }


    render() {
        let {containerInfo} = this.state
        console.log(containerInfo);
        return (
            <div className={"m-3"}>
                <OutputList>
                    <OutputListItem titel={`${names.container} Id`}>
                        <span>{containerInfo.indexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={`${names.container} Name`}>
                        <span>{containerInfo.containerName}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Image Id"}>
                        <span>{containerInfo.imageIndexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Address"}>
                        <span>{containerInfo.domain}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Node Id"}>
                        <span>{containerInfo.nodeIndexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={"SV"}>
                        <span>{containerInfo.SV}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Region"}>
                        <span>{containerInfo.region}</span>
                    </OutputListItem>
                    <OutputListItem titel={"ssh password"}>
                        <PasswordInputComponent value={containerInfo.sshPassword}/>
                    </OutputListItem>
                    <OutputListItem titel={"ssh connection command"}>
                        <span>{`ssh ${containerInfo.containerName}@${containerInfo.domain} -p 2222`}</span>
                    </OutputListItem>

                    <OutputListItem titel={"Background"}>
                        <span>
                            <TextInput value={(containerInfo?.backgroundURL ?? "").toString()} onChange={(newValue) => {
                                this.onChange("backgroundURL", newValue)
                            }}/>
                        </span>
                    </OutputListItem>
                    <OutputListItem titel={"Target State"}>
                        {containerInfo?.targetState}
                        <ButtonComponent
                            text={`${containerInfo?.targetState === "running" ? "Pause" : "Start"} Container`}
                            iconName={"PiArrowSquareOut"}
                            className={""}
                            onClick={async () => {
                                if (containerInfo?.targetState === "running") {
                                    await Containers(containerInfo.indexKey).action("stop")
                                } else {
                                    await Containers(containerInfo.indexKey).action("start")
                                }

                            }}/>
                    </OutputListItem>
                    <OutputListItem titel={"Exposed Ports"}>
                        <span>{(containerInfo?.exposedPorts ?? []).join(", ")}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Http Port"}>
                        <span>{containerInfo?.httpPort}</span>
                    </OutputListItem>
                    <OutputListItem titel={"capacity"}>
                        <span>{containerInfo?.capacity?.cores}x Cores {containerInfo?.capacity?.ram}Gb Ram</span>
                    </OutputListItem>
                    <OutputListItem titel={"lastChanged"}>
                        <span>{DateTime.format(containerInfo.lastChanged, "HH:mm dd.MM.yyyy")}</span>
                    </OutputListItem>
                    <OutputListItem titel={"phase"}>
                        <span>{containerInfo.phase}</span>
                    </OutputListItem>
                    <OutputListItem titel={"phaseEnteredAt"}>
                        <span>{DateTime.format(containerInfo.phaseEnteredAt, "HH:mm dd.MM.yyyy")}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Mounts"}>
                                <span>{(containerInfo?.mounts ?? []).map((mount) => {
                                    return (<>
                                        <OutputList>
                                            <OutputListItem titel={"Volume indexKey"}>
                                                <span>{mount.indexKey}</span>
                                            </OutputListItem>
                                            <OutputListItem titel={"Path in Container"}>
                                                <span>{mount.volumePath}</span>
                                            </OutputListItem>
                                            <ButtonComponent text={"Create Backup"} onClick={async () => {
                                                UI.drawer(Util.unique.newId(10), (state, setState, close) => {
                                                    return (<div className={"p-2"}>
                                                        <TextInput label={"Backup Name"} value={state.backupName}
                                                                   onChange={(newValue) => {

                                                                       setState({backupName: newValue})
                                                                   }}/>

                                                    </div>)

                                                }, (state, close) => {
                                                    close()
                                                }, {
                                                    title: "Create Backup", button: [{
                                                        type: "save",
                                                        text: "Create Backup",
                                                        onClick: async (state, setState, close) => {
                                                            await Volumes(mount.volumeId).createBackup(state?.backupName)

                                                            close()
                                                        }
                                                    }, {
                                                        type: "abort",
                                                        text: "Abbrechen",
                                                        onClick: (inputState, setState, close) => {
                                                            close()
                                                        }
                                                    }]
                                                }).open()
                                            }}/>
                                            <ElementBackups elementId={mount.volumeId}
                                                            applyBackup={async (backupId) => {
                                                                await Volumes(mount.volumeId).applyBackup(backupId)
                                                            }}/>


                                        </OutputList>

                                    </>)

                                })}</span>
                    </OutputListItem>
                    <OutputListItem titel={""}>
                        <ButtonComponent
                            text={`Remove ${names.container} `}
                            onClick={async () => {
                                await Containers(containerInfo.indexKey).remove()

                            }}></ButtonComponent>
                    </OutputListItem>
                </OutputList>

            </div>
        );
    }
}

ContainerSettings.propTypes = {};

ContainerSettings.defaultProps = {};


export default ContainerSettings;